/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Whohasaccess3Inputs */

const en_coinvestments_share_whohasaccess3 = /** @type {(inputs: Coinvestments_Share_Whohasaccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who has access`)
};

/**
* | output |
* | --- |
* | "Who has access" |
*
* @param {Coinvestments_Share_Whohasaccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_whohasaccess3 = /** @type {((inputs?: Coinvestments_Share_Whohasaccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Whohasaccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_whohasaccess3(inputs)
});
export { coinvestments_share_whohasaccess3 as "coInvestments_share_whoHasAccess" }